import { render, staticRenderFns } from "./crosswordPuzzle.vue?vue&type=template&id=166423fc&scoped=true&"
import script from "./crosswordPuzzle.vue?vue&type=script&lang=js&"
export * from "./crosswordPuzzle.vue?vue&type=script&lang=js&"
import style0 from "./crosswordPuzzle.vue?vue&type=style&index=0&id=166423fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166423fc",
  null
  
)

export default component.exports